import type { ReceiptTemplate } from '../schema';

// Existing templates
import { pradaTemplate } from './prada';
import { burberryTemplate } from './burberry';
import { gucciTemplate } from './gucci';
import { appleTemplate } from './apple';
import { zaraTemplate } from './zara';
import { nikeTemplate } from './nike';
import { starbucksTemplate } from './starbucks';
import { walmartTemplate } from './walmart';
import { targetTemplate } from './target';
import { costcoTemplate } from './costco';
import { sevenElevenTemplate } from './seven-eleven';
import { uberTemplate } from './uber';
import { balenciagaTemplate } from './balenciaga';
import { lowesTemplate } from './lowes';
import { womensMedicalTemplate } from './womens-medical';
import { rolexTemplate } from './rolex';

// Luxury templates
import { louisVuittonTemplate } from './louis-vuitton';
import { chanelTemplate } from './chanel';
import { diorTemplate } from './dior';
import { hermesTemplate } from './hermes';
import { cartierTemplate } from './cartier';
import { chromeHeartsTemplate } from './chrome-hearts';
import { denimTearsTemplate } from './denim-tears';
import { goyardTemplate } from './goyard';
import { lululemonTemplate } from './lululemon';
import { monclerTemplate } from './moncler';
import { neimanMarcusTemplate } from './neiman-marcus';
import { saksFifthAvenueTemplate } from './saks-fifth-avenue';
import { sp5derTemplate } from './sp5der';
import { ssenseTemplate } from './ssense';
import { supremeTemplate } from './supreme';
import { theNorthFaceTemplate } from './the-north-face';
import { vanCleefArpelsTemplate } from './van-cleef-arpels';
import { yvesSaintLaurentTemplate } from './yves-saint-laurent';
import { adidasTemplate } from './adidas';

// Grocery & Supermarket templates
import { albertsonsTemplate } from './albertsons';
import { familyDollarTemplate } from './family-dollar';
import { krogerTemplate } from './kroger';
import { publixTemplate } from './publix';
import { safewayTemplate } from './safeway';
import { samsClubTemplate } from './sams-club';
import { shopriteTemplate } from './shoprite';
import { vonsTemplate } from './vons';
import { cvsTemplate } from './cvs';
import { walgreensTemplate } from './walgreens';
import { dollarGeneralTemplate } from './dollar-general';
import { dollarTreeTemplate } from './dollar-tree';

// Food & Restaurant templates
import { mcdonaldsTemplate } from './mcdonalds';
import { burgerKingTemplate } from './burger-king';
import { chickFilATemplate } from './chick-fil-a';
import { dominosTemplate } from './dominos';
import { pizzaHutTemplate } from './pizza-hut';
import { chipotleTemplate } from './chipotle';
import { doordashTemplate } from './doordash';
import { hardeesTemplate } from './hardees';
import { littleCaesarsTemplate } from './little-caesars';
import { pandaExpressTemplate } from './panda-express';
import { popeyesTemplate } from './popeyes';
import { timHortonsTemplate } from './tim-hortons';
import { uberEatsTemplate } from './uber-eats';
import { zaxbysTemplate } from './zaxbys';

// Retail & Department templates
import { amazonTemplate } from './amazon';
import { bestBuyTemplate } from './best-buy';
import { homeDepotTemplate } from './home-depot';
import { sephoraTemplate } from './sephora';
import { nordstromTemplate } from './nordstrom';
import { academySportsTemplate } from './academy-sports';
import { champsSportsTemplate } from './champs-sports';
import { footLockerTemplate } from './foot-locker';
import { goodwillTemplate } from './goodwill';
import { hobbyLobbyTemplate } from './hobby-lobby';
import { kohlsTemplate } from './kohls';
import { macysTemplate } from './macys';
import { marshallsTemplate } from './marshalls';
import { michaelsTemplate } from './michaels';
import { oldNavyTemplate } from './old-navy';
import { rossTemplate } from './ross';
import { samsungTemplate } from './samsung';
import { staplesTemplate } from './staples';
import { tjMaxxTemplate } from './tj-maxx';
import { ultaTemplate } from './ulta';

// Hardware & Auto templates
import { aceHardwareTemplate } from './ace-hardware';
import { harborFreightTemplate } from './harbor-freight';
import { advanceAutoPartsTemplate } from './advance-auto-parts';
import { autozoneTemplate } from './autozone';
import { oreillyAutoPartsTemplate } from './oreilly-auto-parts';

// Gas & Convenience templates
import { bpTemplate } from './bp';
import { chevronTemplate } from './chevron';
import { circleKTemplate } from './circle-k';
import { quiktripTemplate } from './quiktrip';

// Hotel & Hospitality templates
import { hiltonTemplate } from './hilton';
import { airbnbTemplate } from './airbnb';

// Transport & Shipping templates
import { lyftTemplate } from './lyft';
import { fedexTemplate } from './fedex';
import { uspsTemplate } from './usps';
import { upsTemplate } from './ups';

// Fintech templates
import { paypalTemplate } from './paypal';
import { venmoTemplate } from './venmo';
import { squareTemplate } from './square';
import { cashAppTemplate } from './cash-app';

// Resale & Marketplace templates
import { stockxTemplate } from './stockx';
import { goatTemplate } from './goat';
import { ebayTemplate } from './ebay';
import { grailedTemplate } from './grailed';

// New brand templates - Grocery
import { cynibelSupermarketTemplate } from './cynibel-supermarket';

// New brand templates - Auto
import { discountTireTemplate } from './discount-tire';
import { jiffyLubeTemplate } from './jiffy-lube';

// New brand templates - Marketplace
import { facebookMarketplaceTemplate } from './facebook-marketplace';

// New brand templates - Hotels
import { daysInnTemplate } from './days-inn';
import { hamptonInnTemplate } from './hampton-inn';
import { holidayInnTemplate } from './holiday-inn';
import { motel6Template } from './motel-6';
import { qualityInnTemplate } from './quality-inn';
import { vrboTemplate } from './vrbo';

// New brand templates - Transportation
import { americanAirlinesTemplate } from './american-airlines';
import { enterpriseTemplate } from './enterprise';
import { turoTemplate } from './turo';
import { uHaulTemplate } from './u-haul';
import { kyteTemplate } from './kyte';

// New brand templates - Telecom
import { attTemplate } from './att';
import { tMobileTemplate } from './t-mobile';
import { verizonTemplate } from './verizon';

// New brand templates - Fintech
import { applePayTemplate } from './apple-pay';
import { bitcoinTemplate } from './bitcoin';
import { gcashTemplate } from './gcash';
import { goCardlessTemplate } from './gocardless';
import { moneygramTemplate } from './moneygram';
import { stripeTemplate } from './stripe';
import { westernUnionTemplate } from './western-union';
import { zelleTemplate } from './zelle';

// New brand templates - Software & Tech
import { bookingComTemplate } from './booking-com';
import { canvaTemplate } from './canva';
import { chatgptTemplate } from './chatgpt';
import { cleartaxTemplate } from './cleartax';
import { discordTemplate } from './discord';
import { gmailTemplate } from './gmail';
import { googleTemplate } from './google';
import { quickbooksTemplate } from './quickbooks';
import { shopifyTemplate } from './shopify';
import { spotifyTemplate } from './spotify';
import { telegramTemplate } from './telegram';
import { vistaprintTemplate } from './vistaprint';
import { waveTemplate } from './wave';
import { zohoTemplate } from './zoho';

// New brand templates - Rewards
import { fetchRewardsTemplate } from './fetch-rewards';
import { receiptHogTemplate } from './receipt-hog';
import { receiptJarTemplate } from './receipt-jar';
import { swagbucksTemplate } from './swagbucks';

// New brand templates - Charity
import { girlScoutsTemplate } from './girl-scouts';
import { makeAWishTemplate } from './make-a-wish';
import { salvationArmyTemplate } from './salvation-army';

// New brand templates - Misc
import { iphoneTemplate } from './iphone';
import { monsterEnergyTemplate } from './monster-energy';

// New brand templates - Additional
import { jollibeeTemplate } from './jollibee';
import { kingSoopersTemplate } from './king-soopers';
import { olaTemplate } from './ola';
import { ralphsTemplate } from './ralphs';
import { shakeShackTemplate } from './shake-shack';
import { shellTemplate } from './shell';
import { swiggyTemplate } from './swiggy';
import { zomatoTemplate } from './zomato';

// Export individual templates
export {
  // Original
  pradaTemplate,
  burberryTemplate,
  gucciTemplate,
  appleTemplate,
  zaraTemplate,
  nikeTemplate,
  starbucksTemplate,
  walmartTemplate,
  targetTemplate,
  costcoTemplate,
  sevenElevenTemplate,
  uberTemplate,
  balenciagaTemplate,
  lowesTemplate,
  womensMedicalTemplate,
  rolexTemplate,
  // Luxury
  louisVuittonTemplate,
  chanelTemplate,
  diorTemplate,
  hermesTemplate,
  cartierTemplate,
  chromeHeartsTemplate,
  denimTearsTemplate,
  goyardTemplate,
  lululemonTemplate,
  monclerTemplate,
  neimanMarcusTemplate,
  saksFifthAvenueTemplate,
  sp5derTemplate,
  ssenseTemplate,
  supremeTemplate,
  theNorthFaceTemplate,
  vanCleefArpelsTemplate,
  yvesSaintLaurentTemplate,
  adidasTemplate,
  // Grocery
  albertsonsTemplate,
  familyDollarTemplate,
  krogerTemplate,
  publixTemplate,
  safewayTemplate,
  samsClubTemplate,
  shopriteTemplate,
  vonsTemplate,
  cvsTemplate,
  walgreensTemplate,
  dollarGeneralTemplate,
  dollarTreeTemplate,
  // Food
  mcdonaldsTemplate,
  burgerKingTemplate,
  chickFilATemplate,
  dominosTemplate,
  pizzaHutTemplate,
  chipotleTemplate,
  doordashTemplate,
  hardeesTemplate,
  littleCaesarsTemplate,
  pandaExpressTemplate,
  popeyesTemplate,
  timHortonsTemplate,
  uberEatsTemplate,
  zaxbysTemplate,
  // Retail
  amazonTemplate,
  bestBuyTemplate,
  homeDepotTemplate,
  sephoraTemplate,
  nordstromTemplate,
  academySportsTemplate,
  champsSportsTemplate,
  footLockerTemplate,
  goodwillTemplate,
  hobbyLobbyTemplate,
  kohlsTemplate,
  macysTemplate,
  marshallsTemplate,
  michaelsTemplate,
  oldNavyTemplate,
  rossTemplate,
  samsungTemplate,
  staplesTemplate,
  tjMaxxTemplate,
  ultaTemplate,
  // Hardware & Auto
  aceHardwareTemplate,
  harborFreightTemplate,
  advanceAutoPartsTemplate,
  autozoneTemplate,
  oreillyAutoPartsTemplate,
  // Gas
  bpTemplate,
  chevronTemplate,
  circleKTemplate,
  quiktripTemplate,
  // Hotel
  hiltonTemplate,
  airbnbTemplate,
  // Transport
  lyftTemplate,
  fedexTemplate,
  uspsTemplate,
  upsTemplate,
  // Fintech
  paypalTemplate,
  venmoTemplate,
  squareTemplate,
  cashAppTemplate,
  // Resale
  stockxTemplate,
  goatTemplate,
  ebayTemplate,
  grailedTemplate,
  // New - Grocery
  cynibelSupermarketTemplate,
  // New - Auto
  discountTireTemplate,
  jiffyLubeTemplate,
  // New - Marketplace
  facebookMarketplaceTemplate,
  // New - Hotels
  daysInnTemplate,
  hamptonInnTemplate,
  holidayInnTemplate,
  motel6Template,
  qualityInnTemplate,
  vrboTemplate,
  // New - Transportation
  americanAirlinesTemplate,
  enterpriseTemplate,
  turoTemplate,
  uHaulTemplate,
  kyteTemplate,
  // New - Telecom
  attTemplate,
  tMobileTemplate,
  verizonTemplate,
  // New - Fintech
  applePayTemplate,
  bitcoinTemplate,
  gcashTemplate,
  goCardlessTemplate,
  moneygramTemplate,
  stripeTemplate,
  westernUnionTemplate,
  zelleTemplate,
  // New - Software & Tech
  bookingComTemplate,
  canvaTemplate,
  chatgptTemplate,
  cleartaxTemplate,
  discordTemplate,
  gmailTemplate,
  googleTemplate,
  quickbooksTemplate,
  shopifyTemplate,
  spotifyTemplate,
  telegramTemplate,
  vistaprintTemplate,
  waveTemplate,
  zohoTemplate,
  // New - Rewards
  fetchRewardsTemplate,
  receiptHogTemplate,
  receiptJarTemplate,
  swagbucksTemplate,
  // New - Charity
  girlScoutsTemplate,
  makeAWishTemplate,
  salvationArmyTemplate,
  // New - Misc
  iphoneTemplate,
  monsterEnergyTemplate,
  // New - Additional
  jollibeeTemplate,
  kingSoopersTemplate,
  olaTemplate,
  ralphsTemplate,
  shakeShackTemplate,
  shellTemplate,
  swiggyTemplate,
  zomatoTemplate,
};

// Export all templates as an array
export const brandTemplates: ReceiptTemplate[] = [
  // Original
  pradaTemplate,
  burberryTemplate,
  gucciTemplate,
  appleTemplate,
  zaraTemplate,
  nikeTemplate,
  starbucksTemplate,
  walmartTemplate,
  targetTemplate,
  costcoTemplate,
  sevenElevenTemplate,
  uberTemplate,
  balenciagaTemplate,
  lowesTemplate,
  womensMedicalTemplate,
  rolexTemplate,
  // Luxury
  louisVuittonTemplate,
  chanelTemplate,
  diorTemplate,
  hermesTemplate,
  cartierTemplate,
  chromeHeartsTemplate,
  denimTearsTemplate,
  goyardTemplate,
  lululemonTemplate,
  monclerTemplate,
  neimanMarcusTemplate,
  saksFifthAvenueTemplate,
  sp5derTemplate,
  ssenseTemplate,
  supremeTemplate,
  theNorthFaceTemplate,
  vanCleefArpelsTemplate,
  yvesSaintLaurentTemplate,
  adidasTemplate,
  // Grocery
  albertsonsTemplate,
  familyDollarTemplate,
  krogerTemplate,
  publixTemplate,
  safewayTemplate,
  samsClubTemplate,
  shopriteTemplate,
  vonsTemplate,
  cvsTemplate,
  walgreensTemplate,
  dollarGeneralTemplate,
  dollarTreeTemplate,
  // Food
  mcdonaldsTemplate,
  burgerKingTemplate,
  chickFilATemplate,
  dominosTemplate,
  pizzaHutTemplate,
  chipotleTemplate,
  doordashTemplate,
  hardeesTemplate,
  littleCaesarsTemplate,
  pandaExpressTemplate,
  popeyesTemplate,
  timHortonsTemplate,
  uberEatsTemplate,
  zaxbysTemplate,
  // Retail
  amazonTemplate,
  bestBuyTemplate,
  homeDepotTemplate,
  sephoraTemplate,
  nordstromTemplate,
  academySportsTemplate,
  champsSportsTemplate,
  footLockerTemplate,
  goodwillTemplate,
  hobbyLobbyTemplate,
  kohlsTemplate,
  macysTemplate,
  marshallsTemplate,
  michaelsTemplate,
  oldNavyTemplate,
  rossTemplate,
  samsungTemplate,
  staplesTemplate,
  tjMaxxTemplate,
  ultaTemplate,
  // Hardware & Auto
  aceHardwareTemplate,
  harborFreightTemplate,
  advanceAutoPartsTemplate,
  autozoneTemplate,
  oreillyAutoPartsTemplate,
  // Gas
  bpTemplate,
  chevronTemplate,
  circleKTemplate,
  quiktripTemplate,
  // Hotel
  hiltonTemplate,
  airbnbTemplate,
  // Transport
  lyftTemplate,
  fedexTemplate,
  uspsTemplate,
  upsTemplate,
  // Fintech
  paypalTemplate,
  venmoTemplate,
  squareTemplate,
  cashAppTemplate,
  // Resale
  stockxTemplate,
  goatTemplate,
  ebayTemplate,
  grailedTemplate,
  // New - Grocery
  cynibelSupermarketTemplate,
  // New - Auto
  discountTireTemplate,
  jiffyLubeTemplate,
  // New - Marketplace
  facebookMarketplaceTemplate,
  // New - Hotels
  daysInnTemplate,
  hamptonInnTemplate,
  holidayInnTemplate,
  motel6Template,
  qualityInnTemplate,
  vrboTemplate,
  // New - Transportation
  americanAirlinesTemplate,
  enterpriseTemplate,
  turoTemplate,
  uHaulTemplate,
  kyteTemplate,
  // New - Telecom
  attTemplate,
  tMobileTemplate,
  verizonTemplate,
  // New - Fintech
  applePayTemplate,
  bitcoinTemplate,
  gcashTemplate,
  goCardlessTemplate,
  moneygramTemplate,
  stripeTemplate,
  westernUnionTemplate,
  zelleTemplate,
  // New - Software & Tech
  bookingComTemplate,
  canvaTemplate,
  chatgptTemplate,
  cleartaxTemplate,
  discordTemplate,
  gmailTemplate,
  googleTemplate,
  quickbooksTemplate,
  shopifyTemplate,
  spotifyTemplate,
  telegramTemplate,
  vistaprintTemplate,
  waveTemplate,
  zohoTemplate,
  // New - Rewards
  fetchRewardsTemplate,
  receiptHogTemplate,
  receiptJarTemplate,
  swagbucksTemplate,
  // New - Charity
  girlScoutsTemplate,
  makeAWishTemplate,
  salvationArmyTemplate,
  // New - Misc
  iphoneTemplate,
  monsterEnergyTemplate,
  // New - Additional
  jollibeeTemplate,
  kingSoopersTemplate,
  olaTemplate,
  ralphsTemplate,
  shakeShackTemplate,
  shellTemplate,
  swiggyTemplate,
  zomatoTemplate,
];

// Get template by ID
export function getTemplateById(id: string): ReceiptTemplate | undefined {
  return brandTemplates.find((t) => t.id === id);
}

// Template categories for organization
export const templateCategories = {
  luxury: [
    'prada', 'burberry', 'gucci', 'balenciaga', 'rolex', 'louis-vuitton', 'chanel', 'dior', 'hermes', 'cartier',
    'chrome-hearts', 'denim-tears', 'goyard', 'lululemon', 'moncler', 'neiman-marcus', 'saks-fifth-avenue',
    'sp5der', 'ssense', 'supreme', 'the-north-face', 'van-cleef-arpels', 'yves-saint-laurent', 'adidas'
  ],
  tech: ['apple', 'samsung', 'iphone', 'google', 'chatgpt', 'discord', 'spotify', 'telegram', 'canva', 'shopify', 'quickbooks', 'zoho', 'wave', 'cleartax', 'vistaprint', 'gmail'],
  fashion: ['zara', 'nike', 'sephora', 'nordstrom', 'foot-locker', 'champs-sports', 'old-navy', 'ulta'],
  food: [
    'starbucks', 'mcdonalds', 'burger-king', 'chick-fil-a', 'dominos', 'pizza-hut',
    'chipotle', 'doordash', 'hardees', 'jollibee', 'little-caesars', 'panda-express', 'popeyes', 'shake-shack', 'tim-hortons', 'uber-eats', 'zaxbys',
    'monster-energy', 'swiggy', 'zomato'
  ],
  retail: [
    'walmart', 'target', 'costco', '7-eleven', 'lowes', 'amazon', 'best-buy', 'home-depot', 'cvs', 'walgreens',
    'dollar-general', 'dollar-tree', 'albertsons', 'family-dollar', 'kroger', 'publix', 'safeway', 'sams-club', 'shoprite', 'vons',
    'academy-sports', 'goodwill', 'hobby-lobby', 'kohls', 'macys', 'marshalls', 'michaels', 'ross', 'staples', 'tj-maxx',
    'ace-hardware', 'harbor-freight', 'cynibel-supermarket', 'king-soopers', 'ralphs'
  ],
  auto: ['advance-auto-parts', 'autozone', 'oreilly-auto-parts', 'discount-tire', 'jiffy-lube'],
  gas: ['bp', 'chevron', 'circle-k', 'quiktrip', 'shell'],
  transport: ['uber', 'lyft', 'ola', 'american-airlines', 'enterprise', 'turo', 'u-haul', 'kyte'],
  shipping: ['fedex', 'usps', 'ups'],
  hotel: ['hilton', 'airbnb', 'vrbo', 'days-inn', 'hampton-inn', 'holiday-inn', 'motel-6', 'quality-inn', 'booking-com'],
  fintech: ['paypal', 'venmo', 'square', 'cash-app', 'apple-pay', 'bitcoin', 'gcash', 'gocardless', 'moneygram', 'stripe', 'western-union', 'zelle'],
  resale: ['stockx', 'goat', 'ebay', 'grailed', 'facebook-marketplace'],
  medical: ['abortion'],
  telecom: ['att', 't-mobile', 'verizon'],
  rewards: ['fetch-rewards', 'receipt-hog', 'receipt-jar', 'swagbucks'],
  charity: ['girl-scouts', 'make-a-wish', 'salvation-army'],
};

export type TemplateCategory = keyof typeof templateCategories;

// Get templates by category
export function getTemplatesByCategory(category: TemplateCategory): ReceiptTemplate[] {
  const ids = templateCategories[category];
  return brandTemplates.filter((t) => ids.includes(t.id));
}
